import { render, staticRenderFns } from "./UberMenuCopy.vue?vue&type=template&id=55550027&scoped=true"
import script from "./UberMenuCopy.vue?vue&type=script&lang=js"
export * from "./UberMenuCopy.vue?vue&type=script&lang=js"
import style0 from "./UberMenuCopy.vue?vue&type=style&index=0&id=55550027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55550027",
  null
  
)

export default component.exports